import { Society } from 'types';
import { SocietyTypes } from 'types/Society';

export const societyHasTitles = (society: Society) => {
  const isSASociety = society?.societyType === SocietyTypes.SA;
  const hasSharesTitleEnabled = society?.configuration?.sharesTitles?.enabled;
  return isSASociety && hasSharesTitleEnabled;
};
